export default __webpack_public_path__ + "static/media/sticker-oi.f149dd57.png";